import PageTypeA from "../components/pageTypeA/PageTypeA";
import { pagesDataA } from "../data/pagesData";

const Page1 = () => {
  return (
    <PageTypeA title={pagesDataA[0].title} subtitle={pagesDataA[0].subtitle} image={pagesDataA[0].image} />
  );
};

export default Page1;
